module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/2KAsSzhAKuxPf0xttaT8S7-a2bb5978e1ad53fe812912800e87fb20.jpg";